import { OrderCreateBody, OrderItem } from "utils/api/client/types"

export class Order {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: OrderCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<OrderItem> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/orders`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/orders/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
